export default {
  resource:{
    zh: {
      title:"订餐记录",
      empId: "工号",
      empName: "姓名",
      empId:"编号",
      empName:"姓名",
      deptName:"部门",
      job:"岗位",
      duty:"职务",
      xdate:	"订餐日期",
      xdate1: "订餐开始",
      xdate2: "订餐结束",
      xtime:	"订餐时间",
      deviceId:	"机器编号",
      declareNo:"餐别编号",
      declareName:	"餐别", 
      declare: "订餐",
      dinnerDate:"就餐日期",
      dinnerDate1:"就餐开始",
      dinnerDate2:"就餐结束",
      beginTime:	"开始时间",
      endTime:	"结束时间",
      discount:	"折扣",
      remark:	"备注",
      rcType:"记录来源",
      rcType1:"联机记录",
      rcType2:"脱机记录",
      rcType3:"手工添加",
      dcType:"折扣类型",
      dcType1:"按比例",
      dcType2:"按金额",
      status:'就餐状态',
      notFound:"找不到记录，请检查输入的数据是否正确！",
      xdateT1:"按餐别规则",
      xdateT2:"今天"
    }

  },
  dinnerNames:[], //餐别列表
  delConf:["empName","declareName"],
  delKeys:['autoid'],
  params: {
    declareName: {
      key: "declareName",
      data: "",
      method: "Equal",
      type: "select",
      options: [{
        value: "",
        text: "All"
      }]
    },
    xdate:{
      key: "xdate",
      method: "Equal",
      type: "date"
    },
    dinnerDate:{
      key: "dinnerDate",
      method: "Equal",
      type: "date"
    },
    empId:{
      key: "empId",
      method: "Equal",
      type: "number"
    },
    empName:{
      key: "empName",
      method: "Contains",
      type: "text"
    },
    xdate1:{
      key: "xdate",
      tkey: "xdate1",
      method: "GreaterThanOrEqual",
      more: true,
      type: "date"
    },
    xdate2:{
      key: "xdate",
      tkey: "xdate2",
      method: "LessThanOrEqual",
      more: true,
      type: "date"
    },
    dinnerDate1:{
      key: "dinnerDate",
      tkey: "dinnerDate1",
      method: "GreaterThanOrEqual",
      more: true,
      type: "date"
    },
    dinnerDate2:{
      key: "dinnerDate",
      tkey: "dinnerDate2",
      method: "LessThanOrEqual",
      more: true,
      type: "date"
    }
  },
  isShowMore: true,
  listDefine: [
    "empId","empName",
    "declareName",{key:"dinnerDate", formatter:"fdate"},{key:"beginTime", formatter:"ftime"},
    {key:"endTime", formatter:"ftime"},"rcType", {key:"dcType", formatter:"fdcType"},"discount",
    {key:"xtime",vformatter:"fxtime",width:180},"deviceId","declareNo","remark"
  ],
  bodyClass: "table-select", //table-multiselect table-select
  list: [],
  defaultSortName:"autoid",
  defaultSortOrder:"desc",
  sortName: "autoid",
  sortOrder: "desc",
  pageNo: 1,
  pageSize: 18,
  rowCount: 127,
  url: "dinnerDeclare/",
  autoId: "autoid",
  formatter:{
    fxtime(v, cl, item,){
      return this.fdate(item["xdate"]) + " " + this.ftime(item["xtime"])
    },
    fdcType(v){
      return "dcType" + v
    }
  }

}
